<template>
    <div class="EvolutionValidation">
        <HeadPage :title="'Validation des Acquis de l\'Expérience (VAE)'" 
                  :category="'Evolution professionnelle'"
                  :img="'evolution/validation.jpg'"
                  :imgAlt="'Validation head page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "EvolutionValidation",
    data() {
        return {
            content: [
                { 
                    text: [ `La VAE est un outil de <strong>sécurisation des parcours professionnels.</strong>`,
                    `Elle peut vous aider à :`,
                    `<ul>
                        <li>Voir reconnaitre vos expériences et compétences professionnelles</li>
                        <li>Évoluer dans votre emploi</li>
                        <li>Réduire votre parcours de formation</li>
                        <li>Présenter un concours ou intégrer une formation qui exige un diplôme préalable</li>
                        <li>Obtenir une certification particulière pour respecter les conditions réglementaires liées à l'exercice d'une profession</li>
                    </ul>`,
                    `La VAE (Validation des Acquis de l'Experience) permet sur la base d'une expérience professionnelle 
                    salariée ou bénévole d'au moins 1 an à temps complet, d'accéder à <strong>un diplôme ou à une certification professionnelle</strong> 
                    inscrite au Répertoire National des Certifications Professionnelles (RNCP). La VAE est une <strong>reconnaissance 
                    officielle des compétences par une certification.</strong>`,
                    `Peuvent être prises en compte, au titre de la validation, l'ensemble des compétences professionnelles acquises dans l'exercice d'une activité salariée, non 
                    salariée, bénévole, en rapport direct avec les exigences du diplôme visé. Pour que la demande soit recevable, il 
                    faut avoir exercé et pouvoir <strong>justifier d'une activité pendant au moins 1 an en rapport avec le diplôme visé</strong>, 
                    en continu ou en discontinu.`,
                    `Afin d'optimiser vos chances de réussite, les consultants(es) <strong>JobStream</strong>, vous proposent un 
                    accompagnement personnalisé d'une durée moyenne de 18 heures. Réalisé sous forme d'entretiens individuels et collectifs, 
                    il permet d'identifier vos compétences, vous aide à construire votre Dossier Professionnel et vous prépare à l'entretien avec le jury.`
                        ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>